import EmailReader from '@admin/components/email_reader'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  component: <EmailReader provider={ context.provider } />
})

export default Panel(null, mapPropsToPanel)
